import React from 'react';
import PropTypes from 'prop-types';
import notificationTypes from './notificationTypes';
import FormNotificationItem from './formNotificationItem';

const FormNotification = (props) => {
  if (!props.message) {
    return null;
  }

  return (
    <Choose>
      <When condition={Array.isArray(props.message)}>
        <For each="messageItem" of={props.message} index="index">
          <FormNotificationItem message={messageItem.value} type={messageItem.type} />
        </For>
      </When>
      <When condition={props.message.value}>
        <FormNotificationItem message={props.message.value} type={props.message.type} />
      </When>
    </Choose>
  );
};

FormNotification.propTypes = {
  message: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      value: PropTypes.string,
      type: PropTypes.string,
    }),
    PropTypes.arrayOf({
      value: PropTypes.string,
      type: PropTypes.string,
    }),
  ]),
  type: PropTypes.string,
};

FormNotification.defaultProps = {
  message: null,
  type: notificationTypes.ERROR,
};

export default FormNotification;

/**
 * Możliwość przesłania danych:
 * 1. <FormNotification message={{ value: 'wiadomość', type: notificationTypes.ERROR }} />
 * 2. <FormNotification message='Wiadmość' type='notificationTypes.ERROR' />
 * 2. <FormNotification message='Wiadmość' /> - jako notyfikacja o błędzie
 * 3. <FormNotification message={[{ value: 'wiadomość', type: notificationTypes.ERROR }]}/> - kolekcja notyfikacji
 */
